import { render } from "./FooterCTAs.vue?vue&type=template&id=cdfe13f4&scoped=true"
import script from "./FooterCTAs.vue?vue&type=script&lang=js"
export * from "./FooterCTAs.vue?vue&type=script&lang=js"

import "./FooterCTAs.vue?vue&type=style&index=0&id=cdfe13f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdfe13f4"]])

export default __exports__